import { render, staticRenderFns } from "./vpn.vue?vue&type=template&id=b66b37e4&scoped=true&"
import script from "./vpn.vue?vue&type=script&lang=js&"
export * from "./vpn.vue?vue&type=script&lang=js&"
import style0 from "./vpn.vue?vue&type=style&index=0&id=b66b37e4&prod&scoped=true&lang=css&"
import style1 from "./vpn.vue?vue&type=style&index=1&id=b66b37e4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b66b37e4",
  null
  
)

export default component.exports